export default __webpack_public_path__ + "static/media/default_user_profile.c7974681.jpg";